import '@styles/common.less';
import '@styles/layout.less';
import './product.less';
import '@common';

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

import LazyLoad from 'vanilla-lazyload';

Swiper.use([Navigation]);

document.addEventListener('DOMContentLoaded', () => {
  new LazyLoad({
    elements_selector: '.lazy',
    threshold: 300,
  });


  const swiperElTop = document.querySelector('.top-swiper');
  if (swiperElTop) {
    const progressBarTop = document.querySelector('.grid-1 .progress-bar');
    const topSlidesTop = document.querySelectorAll('.top-swiper .swiper-slide');
    const initialWidthTop = 100 / topSlidesTop.length;
    progressBarTop.style.width = `${initialWidthTop}%`;
    progressBarTop.style.transition = 'width 0.3s ease';
    const swiperTop = new Swiper(swiperElTop, {
      loop: false,
      slidesPerView: 1,
      // speed: 600,
      autoplay: false,
      navigation: {
        prevEl: '.grid-1 .prev-button',
        nextEl: '.grid-1 .next-button',
      }
    });
    swiperTop.on('realIndexChange', () => {
      const currentIndex = swiperTop.realIndex;
      const currentWidth = initialWidthTop * (currentIndex + 1);
      progressBarTop.style.width = `${currentWidth}%`;
    });
  }

  const swiperElBottom = document.querySelector('.bottom-swiper');
  if (swiperElBottom) {
    const progressBarBottom = document.querySelector('.grid-2 .progress-bar');
    const bottomSlidesBottom = document.querySelectorAll('.bottom-swiper .swiper-slide');
    const initialWidthBottom = 100 / bottomSlidesBottom.length;
    progressBarBottom.style.width = `${initialWidthBottom}%`;
    progressBarBottom.style.transition = 'width 0.3s ease';
    const swiperBottom = new Swiper(swiperElBottom, {
      loop: false,
      slidesPerView: 1,
      // speed: 600,
      autoplay: false,
      navigation: {
        prevEl: '.grid-2 .prev-button',
        nextEl: '.grid-2 .next-button',
      }
    });
    swiperBottom.on('realIndexChange', () => {
      const currentIndex = swiperBottom.realIndex;
      const currentWidth = initialWidthBottom * (currentIndex + 1);
      progressBarBottom.style.width = `${currentWidth}%`;
    });
  }
});
